import {
  redeemPointsForCoupon as publicRedeemPointsForCoupon,
  redeemCurrentMemberPointsForCoupon as publicRedeemCurrentMemberPointsForCoupon,
  getLoyaltyCoupon as publicGetLoyaltyCoupon,
  bulkGetLoyaltyCoupon as publicBulkGetLoyaltyCoupon,
  getCurrentMemberCoupons as publicGetCurrentMemberCoupons,
  queryLoyaltyCoupons as publicQueryLoyaltyCoupons,
  typedQueryLoyaltyCoupons as publicTypedQueryLoyaltyCoupons,
  deleteLoyaltyCoupon as publicDeleteLoyaltyCoupon,
} from './loyalty-v1-coupon-coupons.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  LoyaltyCouponQuery,
  LoyaltyCouponsQueryBuilder,
  typedQueryLoyaltyCoupons as universalTypedQueryLoyaltyCoupons,
} from './loyalty-v1-coupon-coupons.universal.js';
import { onCouponCreated as publicOnCouponCreated } from './loyalty-v1-coupon-coupons.public.js';
import { onCouponDeleted as publicOnCouponDeleted } from './loyalty-v1-coupon-coupons.public.js';

function customQueryLoyaltyCoupons(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryLoyaltyCoupons(httpClient)(),
    typedQueryFunction: (query: LoyaltyCouponQuery) =>
      publicTypedQueryLoyaltyCoupons(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): LoyaltyCouponsQueryBuilder;
  function overloadedQuery(
    query: LoyaltyCouponQuery
  ): ReturnType<typeof universalTypedQueryLoyaltyCoupons>;
  function overloadedQuery(query?: LoyaltyCouponQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const redeemPointsForCoupon: MaybeContext<
  BuildRESTFunction<typeof publicRedeemPointsForCoupon> &
    typeof publicRedeemPointsForCoupon
> = /*#__PURE__*/ createRESTModule(publicRedeemPointsForCoupon);
export const redeemCurrentMemberPointsForCoupon: MaybeContext<
  BuildRESTFunction<typeof publicRedeemCurrentMemberPointsForCoupon> &
    typeof publicRedeemCurrentMemberPointsForCoupon
> = /*#__PURE__*/ createRESTModule(publicRedeemCurrentMemberPointsForCoupon);
export const getLoyaltyCoupon: MaybeContext<
  BuildRESTFunction<typeof publicGetLoyaltyCoupon> &
    typeof publicGetLoyaltyCoupon
> = /*#__PURE__*/ createRESTModule(publicGetLoyaltyCoupon);
export const bulkGetLoyaltyCoupon: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetLoyaltyCoupon> &
    typeof publicBulkGetLoyaltyCoupon
> = /*#__PURE__*/ createRESTModule(publicBulkGetLoyaltyCoupon);
export const getCurrentMemberCoupons: MaybeContext<
  BuildRESTFunction<typeof publicGetCurrentMemberCoupons> &
    typeof publicGetCurrentMemberCoupons
> = /*#__PURE__*/ createRESTModule(publicGetCurrentMemberCoupons);
export const deleteLoyaltyCoupon: MaybeContext<
  BuildRESTFunction<typeof publicDeleteLoyaltyCoupon> &
    typeof publicDeleteLoyaltyCoupon
> = /*#__PURE__*/ createRESTModule(publicDeleteLoyaltyCoupon);
export const queryLoyaltyCoupons: MaybeContext<
  BuildRESTFunction<typeof customQueryLoyaltyCoupons> &
    typeof customQueryLoyaltyCoupons
> = /*#__PURE__*/ createRESTModule(customQueryLoyaltyCoupons);
/**
 * Triggered when a loyalty coupon is created.
 */
export const onCouponCreated: BuildEventDefinition<
  typeof publicOnCouponCreated
> &
  typeof publicOnCouponCreated = createEventModule(publicOnCouponCreated);
/**
 * Triggered when a loyalty coupon is deleted.
 */
export const onCouponDeleted: BuildEventDefinition<
  typeof publicOnCouponDeleted
> &
  typeof publicOnCouponDeleted = createEventModule(publicOnCouponDeleted);

export {
  Type,
  Status,
  SortOrder,
  WebhookIdentityType,
} from './loyalty-v1-coupon-coupons.universal.js';
export {
  LoyaltyCoupon,
  CouponReference,
  Specification,
  SpecificationTypeDetailsOneOf,
  SpecificationScopeOrMinSubtotalOneOf,
  BuyXGetY,
  Scope,
  RedeemPointsForCouponRequest,
  RedeemPointsForCouponResponse,
  RedeemCurrentMemberPointsForCouponRequest,
  RedeemCurrentMemberPointsForCouponResponse,
  RedeemMemberPointsForDiscountAmountCouponRequest,
  RedeemMemberPointsForDiscountAmountCouponResponse,
  GetLoyaltyCouponRequest,
  GetLoyaltyCouponResponse,
  BulkGetLoyaltyCouponRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  BulkGetLoyaltyCouponResponse,
  CouponsInSite,
  GetCurrentMemberCouponsRequest,
  GetCurrentMemberCouponsResponse,
  QueryLoyaltyCouponRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Paging,
  QueryLoyaltyCouponResponse,
  PagingMetadataV2,
  Cursors,
  DeleteLoyaltyCouponRequest,
  DeleteLoyaltyCouponResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CouponCreatedEnvelope,
  CouponDeletedEnvelope,
  RedeemPointsForCouponOptions,
  BulkGetLoyaltyCouponOptions,
  LoyaltyCouponsQueryResult,
  LoyaltyCouponsQueryBuilder,
  LoyaltyCouponQuerySpec,
} from './loyalty-v1-coupon-coupons.universal.js';
export { utils } from './loyalty-v1-coupon-coupons.universal.js';
export {
  TypeWithLiterals,
  StatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  LoyaltyCouponQuery,
} from './loyalty-v1-coupon-coupons.universal.js';
